import React from "react";
import ListPageLayout from "@layouts/ListPageLayout";
import {withRouter} from "react-router";

import GeneraChargeFilterFrom from './GeneraChargeFilterFrom';
import GeneraChargeListTable from './GeneraChargeListTable';
import genera_store, {filter_store} from "@store/Statistic/GeneraCharge/GeneraChargeStore";
import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
class GeneraChargeList extends React.PureComponent {
    constructor(props) {
        super();
        let id = props.location.id;
        let state = props.location.state;
        let username = props.location.username;
        this.updateDatas(state, id, username);
    }

    componentWillReceiveProps(props, nextContext) {
        let state = props.location.state;
        this.updateDatas(state);
    }

    updateDatas(state) {
        breadcrumb_store.resetByName('代充列表', '代充列表')
        if (state === undefined) {
            filter_store.resetAttr()
        } else {
            filter_store.setAttr(state)
        }
        genera_store.state = state;
    }

    render() {
        return (
            <ListPageLayout
                isCustomHeader
                header={<GeneraChargeFilterFrom/>}
                list={<GeneraChargeListTable/>}
            />
        );
    }
}

export default GeneraChargeList;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/GeneraCharge/GeneraChargeList.jsx